import React, {FC} from 'react';

import Panel from '@/components/Panels/common/Panel';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';

import LogoutIcon from '@mui/icons-material/Logout';

import {User} from '@/domain/entities/User';

import {PANEL_WIDTH} from '@/config';

//TYPES
export type ProfilePanelProps = {
  user?: User,
  onLogout: () => void
};

const ProfilePanel: FC<ProfilePanelProps> = ({user, onLogout}) => {
  if(!user) return;

  const {first_name, last_name, email} = user;

  const capitalize = first_name.substring(0,1);

  return <Panel width={PANEL_WIDTH.profile}>
    <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'space-between', gap: 1}}>
      <Stack direction="row" sx={{gap: 1}}>
        <Avatar sx={styles.avatar}>{capitalize}</Avatar>
        <Stack direction="column" sx={{alignItems: 'flex-start'}}>
          <Typography sx={{fontWeight: 700}}>{first_name} {last_name}</Typography>
          <Typography sx={{color: 'grey.500'}}>{email}</Typography>
        </Stack>
      </Stack>
      <LogoutIcon onClick={onLogout}/>
    </Stack>
  </Panel>;
};
export default ProfilePanel;

const styles = {
  avatar: {
    bgcolor: 'primary.main',
    width: 48,
    height: 48
  }
};